var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-progress-linear',{attrs:{"active":_vm.busy,"indeterminate":_vm.busy,"absolute":"","top":"","color":"primary"}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }